import { render, staticRenderFns } from "./QualityAdd.vue?vue&type=template&id=70496825&scoped=true&"
import script from "./QualityAdd.vue?vue&type=script&lang=js&"
export * from "./QualityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70496825",
  null
  
)

export default component.exports